import { render, staticRenderFns } from "./ProductsWholesaleDiscountsCreate.vue?vue&type=template&id=99130ba6&lang=pug&"
import script from "./ProductsWholesaleDiscountsCreate.vue?vue&type=script&lang=js&"
export * from "./ProductsWholesaleDiscountsCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProductsWholesaleDiscountsCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductsWholesaleDiscountsCreate.vue"
export default component.exports